import { Injectable, EventEmitter } from '@angular/core'

import { PathNode } from '@mprep/shared/data/models'
import { PathService, UserTaskService } from '@mprep/shared/lib/data/services'

@Injectable()
export class PathResetService {

  private _resetEventEmitter: EventEmitter<PathNode> = new EventEmitter<PathNode>()
  private _onPathReset: EventEmitter<PathNode> = new EventEmitter<PathNode>()

  public constructor(private _userTaskService: UserTaskService) {}

  public resetPath(pathRoot: PathNode) {
    return this._userTaskService.resetUserTasks(pathRoot).map(() => true)
      .do(() => this._onPathReset.emit(pathRoot))
  }

  public onPathReset() {
    return this._onPathReset
  }

  public getResetEventEmitter() {
    return this._resetEventEmitter
  }

  public triggerPathReset(pathRoot: PathNode) {
    this._resetEventEmitter.emit(pathRoot)
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/path-reset/path-reset.service.ts